import { useEffect, useRef } from "react";
import { loadOpenInstallSdk } from "../../../utils/loadOpenInstallSdk";
import "./LandingPage.scss";

const DEFAULT_OPENINSTALL_APP_KEY = "jmhi3q";
const LandingPage = () => {
  // 获取当前 URL 中的查询参数
  const queryParams = new URLSearchParams(window.location.search);
  const AppName = queryParams.get("AppName");
  const p0 = queryParams.get("p0");
  const p1 = queryParams.get("p1");
  const p2 = queryParams.get("p2");
  const p3 = queryParams.get("p3");
  const p4 = queryParams.get("p4");
  const p5 = queryParams.get("p5");
  const p6 = queryParams.get("p6");
  const fbclid = queryParams.get("fbclid");
  const buttonRef = useRef(null);

  const buildURL = (p0, p1, p2, p3, p4, p5, p6, fbclid, fbpid) => {
    let tracker_token;
    let campaign;
    let adgroup;
    let creative;
    if (!p0) {
      return null;
    }
    tracker_token = p0;
    if (p1 || p2) {
      campaign = p1 + "(" + p2 + ")";
    } else {
      campaign = "";
    }
    if (p3 || p4) {
      adgroup = p3 + "(" + p4 + ")";
    } else {
      adgroup = "";
    }
    if (p5 || p6) {
      creative = p5 + "(" + p6 + ")";
    } else {
      creative = "";
    }
    if (!fbclid) {
      fbclid = "";
    }
    if (!fbpid) {
      fbpid = "";
    }
    // build a tracker URL
    let params = { campaign, adgroup, creative, fbclid, fbpid };
    let newURL =
      `https://app.adjust.${AppName === "JourneyCo1" ? "com" : "world"}/` +
      tracker_token +
      "?" +
      Object.keys(params)
        .map((key) => key + "=" + encodeURIComponent(params[key]))
        .join("&");
    return newURL;
  };

  const getFbPid = () => {
    let fbPid = document.cookie.match(/(^|;) ?_fbp=([^;]*)(;|$)/);
    if (fbPid) {
      return fbPid[2];
    } else {
      return null;
    }
  };

  const fbPid = getFbPid();
  const handleClickGourl = buildURL(p0, p1, p2, p3, p4, p5, p6, fbclid, fbPid);

  const pixelMap = {
    Creashelf: "1427467595091189",
    DMet: "1189792802456725", // IOS
    hcPro: "1108557397751525",
    DMetAndroid: "720664480525104", // Android
    HC: "1247957117329400",
    ExopetPals: "1218561999750032",
    HeartSparkle: "1255594449377162",
    JourneyCo: "804386685600549",
    JourneyCo1: "1497094034849792",
    Fumo: "1257303302707275",
    Pixura: "1357883352655020",
    Kodii: "780739134510607",
    Dimochat: "1134490184747076",
    Dimochat1: "1134490184747076",
    MeetHer: "2684797488527451",
    Funnect: "1706158717350153",
  };
  const tokenMap = {
    Creashelf: "1ovh5rku",
    DMet: "1o4r3yl9",
    hcPro: "1op8dbmg",
    DMetAndroid: "1o8r7x4u", // Android
    HC: "1o5koqsz",
    ExopetPals: "1o64c33k",
    HeartSparkle: "1qkzy05w",
    JourneyCo: "1q43nhs4",
    JourneyCo1: "1ulkylbi",
    Fumo: "1qvw1bfd",
    Pixura: "1qme3ywv",
    Kodii: "1rkc0iel",
    Dimochat: "1stsvvey",
    Dimochat1: "1ss2wggt",
    MeetHer: "1uwdyhw0",
    Funnect: "23yozmi5",
  };

  // 使用 OpenInstall 的 AppName 列表，不在此列表中的直接跳转
  const OPENINSTALL_APP_NAMES = ["Kodii", "JourneyCo1", "Glowp","Chimeet"];

  // OpenInstall appKey 映射，未配置的 AppName 使用默认值
  const appKeyMap = {
    Kodii: "pl5b9j",
    Glowp: "bu93tq",
    Chimeet: "mxa0gc",
    JourneyCo1: DEFAULT_OPENINSTALL_APP_KEY,
  };

  const handleGoUrl = () => {
    const token = tokenMap[AppName];
    if (handleClickGourl) {
      return (window.location.href = handleClickGourl);
    } else {
      return (window.location.href = `https://app.adjust.${
        AppName === "JourneyCo1" ? "com" : "world"
      }/${
        token || "1ovh5rku"
      }?campaign={{campaign.name}}%20%28{{campaign.id}}%29&adgroup={{adset.name}}%20%28{{adset.id}}%29&creative={{ad.name}}%20%28{{ad.id}}%29&fbclid=xxxxx&fbpid=xxxxxx&fb_pixel_id=xxxxx&fb_access_token=xxxxxxxx`);
    }
  };

  const handleClickGo = () => {
    handleGoUrl();
  };

  const pixelId = pixelMap[AppName];
  useEffect(() => {
    const scriptElement = document.createElement("script");
    scriptElement.textContent = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', '${
      pixelId || 1427467595091189
    }');fbq('track', 'PageView');`;
    document.head.appendChild(scriptElement);
    return () => {
      document.head.removeChild(scriptElement);
    };
  }, []);

  useEffect(() => {
    const noscriptElement = document.createElement("noscript");
    noscriptElement.textContent = `<img height="1" width="1" style="display:none"src="https://www.facebook.com/tr?id=${
      pixelId || 1427467595091189
    }&ev=PageView&noscript=1"/>`;
    document.head.appendChild(noscriptElement);
    return () => {
      document.head.removeChild(noscriptElement);
    };
  }, []);

  useEffect(() => {
    if (!OPENINSTALL_APP_NAMES.includes(AppName)) {
      handleGoUrl();
      return;
    }

    const appKey = appKeyMap[AppName] ?? DEFAULT_OPENINSTALL_APP_KEY;
    let cancelled = false;

    loadOpenInstallSdk(appKey)
      .then((OpenInstall) => {
        if (cancelled) return;

        const params = OpenInstall.parseUrlParams();
        const campaign = p1 || p2 ? `${p1}${p2 ? `(${p2})` : ""}` : null;
        const channelCode = params.channelCode || campaign;

        new OpenInstall(
          {
            appKey,
            channelCode,
            onready: function () {
              if (!buttonRef.current) return;

              buttonRef.current.onclick = () => {
                this.wakeupOrInstall({
                  channelCode,
                });
              };
              setTimeout(() => {
                console.log("模拟点击按钮");
                buttonRef.current?.click();
                Promise.resolve().then(() => {
                  handleGoUrl();
                });
              }, 1000);
            },
          },
          params
        );
      })
      .catch((err) => {
        console.error(err);
        if (!cancelled) handleGoUrl();
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className={`home ${AppName}`}>
      <div
        className={`download ${AppName}`}
        ref={buttonRef}
        onclick={handleClickGo}
      ></div>
    </div>
  );
};

export default LandingPage;
